import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { RejectReasonDto } from '../../models/medicalCheckups/rejectReasonDto';
import { medicalCheckupsService } from '../../services/medicalCheckupsService';

interface RejectReasonsAutocompleteProps {
    value: RejectReasonDto[];
    onChange: (reasons: RejectReasonDto[]) => void;
    label?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
}

const RejectReasonsAutocomplete: React.FC<RejectReasonsAutocompleteProps> = ({
    value,
    onChange,
    label = 'Причина',
    style = {},
    disabled = false,
}) => {
    const [options, setOptions] = useState<RejectReasonDto[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        medicalCheckupsService.getRejectReasons()
            .then(r => setOptions(r.data.data))
            .catch(error => {
                console.error('Error fetching reject reasons:', error);
                setOptions([]);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <Autocomplete
            multiple
            disabled={disabled}
            options={options}
            getOptionLabel={option => option.name}
            groupBy={option => option.group}
            value={disabled ? [] : value}
            onChange={(_, newValue) => onChange(newValue)}
            isOptionEqualToValue={(option, optionValue) => option.id === optionValue.id}
            noOptionsText="Не найдено"
            loadingText="Загрузка..."
            loading={loading}
            size="small"
            sx={{ opacity: disabled ? 0.5 : 1 }}
            renderInput={params => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    style={{ ...style, minWidth: '200px' }}
                    placeholder={value.length === 0 || disabled ? 'Все' : undefined}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default RejectReasonsAutocomplete;
